export default __webpack_public_path__ + "aa60f294209a3eb47d8db6d97bf44a69.svg";